export default __webpack_public_path__ + "static/media/breakfast4.a32d739f.jpeg";